var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4C11.5 4.3 11.6 4.5 11.8 4.7L16.1 9L2.5 9C2 9 1.5 9.4 1.5 10C1.5 10.6 2 11 2.5 11L16.1 11L11.8 15.3C11.6 15.5 11.5 15.7 11.5 16C11.5 16.5 11.9 17 12.5 17C12.8 17 13 16.9 13.2 16.7L19.2 10.7C19.4 10.5 19.5 10.3 19.5 10C19.5 9.7 19.4 9.5 19.2 9.3L13.2 3.3C13 3.1 12.8 3 12.5 3C11.9 3 11.5 3.5 11.5 4Z",
    fill: "#F5F9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b1305eb4bb2482b3c1563e1d330d9ea6.svg";
export { ForwardRef as ReactComponent };